import React, { useState } from 'react';

function Lists({ lists, setLists }) {
  const [inputValues, setInputValues] = useState({});
  const [draggingItem, setDraggingItem] = useState(null);
  const [draggingList, setDraggingList] = useState(null);
  const [dragOverItem, setDragOverItem] = useState(null);

  const handleInputChange = (listName, value) => {
    setInputValues(prev => ({ ...prev, [listName]: value }));
  };

  const addItem = (listName) => {
    const value = inputValues[listName]?.trim();
    if (!value) return;
    if (lists[listName].includes(value)) return;
    setLists(prev => ({
      ...prev,
      [listName]: [...prev[listName], value]
    }));
    setInputValues(prev => ({ ...prev, [listName]: '' }));
  };

  const removeItem = (listName, item) => {
    setLists(prev => ({
      ...prev,
      [listName]: prev[listName].filter(i => i !== item)
    }));
  };

  const handleKeyDown = (e, listName) => {
    if (e.key === 'Enter') addItem(listName);
  };

  const handleDragStart = (listName, item) => {
    setDraggingItem(item);
    setDraggingList(listName);
  };

  const handleDragOver = (e, item) => {
    e.preventDefault();
    setDragOverItem(item);
  };

  const handleDrop = (listName, targetItem) => {
    if (!draggingItem || draggingList !== listName || draggingItem === targetItem) return;
    const items = [...lists[listName]];
    const dragIndex = items.indexOf(draggingItem);
    const targetIndex = items.indexOf(targetItem);
    items.splice(dragIndex, 1);
    items.splice(targetIndex, 0, draggingItem);
    setLists(prev => ({ ...prev, [listName]: items }));
    setDraggingItem(null);
    setDraggingList(null);
    setDragOverItem(null);
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
    setDraggingList(null);
    setDragOverItem(null);
  };

  return (
    <div>
      <div className="page-header">
        <h1>Lists</h1>
        <p>Manage the dropdown options used throughout the Show Flow grid. Add or remove items from any list. Drag items to reorder.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
        {Object.entries(lists).map(([listName, items]) => (
          <div key={listName} className="card">
            <h3 style={{
              fontSize: '15px',
              fontWeight: '700',
              color: '#1a1a2e',
              marginBottom: '16px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4299e1'
            }}>
              {listName}
            </h3>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px', minHeight: '40px' }}>
              {items.length === 0 && (
                <p style={{ color: '#a0aec0', fontSize: '13px', fontStyle: 'italic' }}>No items yet. Add one below.</p>
              )}
              {items.map((item, index) => (
                <div
                  key={index}
                  draggable
                  onDragStart={() => handleDragStart(listName, item)}
                  onDragOver={e => handleDragOver(e, item)}
                  onDrop={() => handleDrop(listName, item)}
                  onDragEnd={handleDragEnd}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    backgroundColor: '#ebf8ff',
                    border: dragOverItem === item && draggingList === listName ? '2px solid #4299e1' : '1px solid #bee3f8',
                    borderRadius: '20px',
                    padding: '4px 10px 4px 12px',
                    fontSize: '13px',
                    color: '#2b6cb0',
                    fontWeight: '500',
                    cursor: 'grab',
                    opacity: draggingItem === item ? 0.4 : 1,
                  }}
                >
                  <span style={{ color: '#90cdf4', fontSize: '11px', marginRight: '2px' }}>⠿</span>
                  {item}
                  <button
                    onClick={() => removeItem(listName, item)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#90cdf4',
                      fontSize: '16px',
                      lineHeight: '1',
                      padding: '0',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    title="Remove item"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                type="text"
                placeholder={`Add to ${listName}...`}
                value={inputValues[listName] || ''}
                onChange={e => handleInputChange(listName, e.target.value)}
                onKeyDown={e => handleKeyDown(e, listName)}
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  fontSize: '13px',
                  outline: 'none',
                  color: '#1a1a2e'
                }}
              />
              <button
                onClick={() => addItem(listName)}
                style={{
                  backgroundColor: '#4299e1',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '8px 16px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
              >
                + Add
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Lists;